import React, {Component} from 'react'
import {MDBTabPane, MDBBtn, MDBBadge} from "mdbreact";
import Compressor from "compressorjs";
import {v4 as uuidv4} from 'uuid'
import firebase from "../../../../Config/firebase";

import classes from './BannerItem.module.css'


const storageRef = firebase.storage()

class BannerItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    fileCompress = (file) => {
        return new Promise((resolve, reject) => {
            new Compressor(file, {
                file: 'File',
                quality: 0.7,
                maxWidth: 1200,
                maxHeight: 600,
                success(file) {
                    return resolve({
                        success: true,
                        file: file
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                }
            })
        })
    }

    uploadImageCallBack = (e) => {
        return new Promise(async (resolve, reject) => {
            const file = e.target.files[0]
            const compressState = await this.fileCompress(file)
            if (compressState.success) {
                console.log(compressState)
                const fileName = uuidv4()
                storageRef.ref().child("Banner/" + fileName).put(compressState.file)
                    .then(async snapshot => {
                        const downloadURL = await storageRef.ref().child("Banner/" + fileName).getDownloadURL()
                        resolve({
                            success: true,
                            data: {link: downloadURL}
                        })
                    })
            }
        })
    }

    render() {
        return (
            <MDBTabPane tabId={this.props.index} role="tabpanel">

                <label className="grey-text">
                    Title
                </label>
                <input type="text" className="form-control"
                       onChange={(e) => this.props.onChangeItem(this.props.index, "title", e.target.value)}
                       value={this.props.data.title}
                />

                <label className="grey-text">
                    Description
                </label>
                <input type="text" className="form-control"
                       onChange={(e) => this.props.onChangeItem(this.props.index, "description", e.target.value)}
                       value={this.props.data.description}
                />

                <label className="grey-text">
                    Link
                </label>
                <input type="text" className="form-control"
                       onChange={(e) => this.props.onChangeItem(this.props.index, "link", e.target.value)}
                       value={this.props.data.link}
                />

                <label className="grey-text">
                    Image <MDBBadge>Recommended Size: 1200x600</MDBBadge>
                </label>
                <input type="file" className="form-control" accept="image/*"
                       onChange={async (e) => {
                           const uploadState = await this.uploadImageCallBack(e)
                           if (uploadState.success) {
                               this.props.onChangeItem(this.props.index, "image", uploadState.data.link)
                           }

                       }
                       }>
                </input>

                <img src={this.props.data.image} className="img-fluid" alt=""/>

                <MDBBtn color="link"
                        onClick={(e) => {
                            this.props.removeItem(this.props.index)
                        }}>
                    Remove
                </MDBBtn>

                <MDBBtn color="secondary"
                        className={classes.SubmitBtn}
                        onClick={(e) => {
                            this.props.saveList()
                        }}>
                    Save
                </MDBBtn>
            </MDBTabPane>
        );
    }

}

export default BannerItem